export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L1_solid_x_01_f_mask.a1a68cf5.png";